import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.css'],
    standalone: false
})
export class PageHeaderComponent implements OnInit {

    urls: { nome: String; path?: String }[] = []
    @Input() urlName : String = ""
    @Input() secondaryUrlName : String = ""
    @Input() urlPath : String = ""
    @Input() Tutorial: boolean = false
    @Input() Classificacao = ''

    constructor(private route: ActivatedRoute, private router: Router) {}

    ngOnInit() {
        this.route.url.subscribe(url => {
            this.urls = url.map(v => ({nome: v.path.charAt(0).toUpperCase() + v.path.slice(1), path: v.path}))
            if(this.urlName) this.urls[0].nome = this.urlName
            if(this.urlPath) this.urls[0].path = this.urlPath
            if(this.secondaryUrlName) this.urls[1] = {nome: this.secondaryUrlName}
        })
        
    }

    navigate(route: any) {
        this.router.navigate([`${route}`])
    }

}